import { type Nurse, type NurseFullRole, WageType } from "./models";

/** Each role's average current hourly wage across `nurses`, to 2 decimals; a role nobody has a current hourly wage for is left out. */
export const roleAverageWagesOf = (nurses: readonly Nurse[]): Partial<Record<NurseFullRole, string>> => {
	const wagesByRole: Partial<Record<NurseFullRole, number[]>> = {};
	for (const nurse of nurses) {
		const currentWage = nurse.baseWages?.find((baseWage) => baseWage.wage > 0 && baseWage.wageType !== WageType.Annually && !baseWage.endTime);
		if (currentWage && nurse.role) wagesByRole[nurse.role] = [...(wagesByRole[nurse.role] ?? []), currentWage.wage];
	}
	const averageWages: Partial<Record<NurseFullRole, string>> = {};
	for (const [role, wages] of Object.entries(wagesByRole)) {
		// Object.entries widens the keys to string; they are the roles written above.
		averageWages[role as NurseFullRole] = (wages.reduce((sum, wage) => sum + wage, 0) / wages.length).toFixed(2);
	}
	return averageWages;
};
